import React from 'react';
import PropTypes from 'prop-types';
import {Spinner} from 'react-bootstrap';
import replayerTvIcon from '../../images/replayer_tv_icon.svg';
import replayerTvRedIcon from '../../images/replayer_tv_red.svg';

const PublicPartnerSkyworkTvSection = ({
  activeMode,
  channels,
  children,
  empty,
  error,
  labels,
  loading,
  loadingStore,
  onOpenStore,
  onOpenSubscriptionOptions,
  onRetry,
  onSelectChannel,
  onSelectReplay,
  onSelectUpcoming,
  replayDisabled,
  selectedChannelId,
  showChannelFilter,
  showSubscriptionOptions,
  storeLoaded,
  upcomingDisabled
}) => (
  <section id="club-matches" className="replayer-club-page__tv" aria-labelledby="replayer-club-tv-title">
    <div className="replayer-club-page__tv-heading">
      <div className="replayer-club-page__tv-title">
        <span className="replayer-club-page__section-number">
          <strong>{labels.number}</strong>
          <span>REPLAYERTV</span>
        </span>
        <p>{labels.eyebrow}</p>
        <h2 id="replayer-club-tv-title">
          {labels.title}
          <span>{labels.titleAccent}</span>
        </h2>
      </div>
      <div className="replayer-club-page__tv-intro">
        <img src={replayerTvIcon} alt="" aria-hidden="true"/>
        <div>
          <h3>{labels.intro}</h3>
          <p>{labels.purchaseDescription}</p>
          <p>{labels.renewalNote}</p>
        </div>
      </div>
    </div>

    {channels.length > 0 && (
      <div className="replayer-club-page__tv-subsection">
        <p className="replayer-club-page__tv-subsection-eyebrow">{labels.channelsEyebrow}</p>
        <h3>{labels.channelsTitle}</h3>
      </div>
    )}

    {channels.length > 0 && (
      <div className="replayer-club-page__channel-selector" aria-label={labels.channelAriaLabel}>
        {showChannelFilter && (
          <button
            type="button"
            className={!selectedChannelId ? 'is-active' : ''}
            aria-pressed={!selectedChannelId}
            onClick={() => onSelectChannel(null)}
          >
            <span className="replayer-club-page__channel-logo replayer-club-page__channel-logo--all">
              <img src={replayerTvRedIcon} alt="" aria-hidden="true"/>
            </span>
            <span className="replayer-club-page__channel-copy">
              <small>{labels.channelsEyebrow}</small>
              <strong>{labels.allChannelsLabel}</strong>
              <span>{labels.allChannelsDescription}</span>
            </span>
            <span className="replayer-club-page__channel-arrow" aria-hidden="true">→</span>
          </button>
        )}
        {channels.map(channel => (
          <button
            type="button"
            key={channel.id}
            className={(
              String(selectedChannelId) === String(channel.id)
              || (!showChannelFilter && channels.length === 1)
            ) ? 'is-active' : ''}
            aria-label={channel.name}
            aria-pressed={(
              String(selectedChannelId) === String(channel.id)
              || (!showChannelFilter && channels.length === 1)
            )}
            onClick={() => onSelectChannel(channel.id)}
          >
            <span className={`replayer-club-page__channel-logo ${channel.logoUrl ? '' : 'replayer-club-page__channel-logo--fallback'}`}>
              <img src={channel.logoUrl || replayerTvIcon} alt="" aria-hidden="true"/>
            </span>
            <span className="replayer-club-page__channel-copy">
              <small>{labels.channelLabel}</small>
              <strong>{channel.name}</strong>
              <span>{labels.channelDescription}</span>
            </span>
            <span className="replayer-club-page__channel-arrow" aria-hidden="true">→</span>
          </button>
        ))}
      </div>
    )}

    <div className="replayer-club-page__tv-subsection">
      <p className="replayer-club-page__tv-subsection-eyebrow">{labels.catalogChoicesEyebrow}</p>
      <h3>{labels.catalogChoicesTitle}</h3>
    </div>

    <div className="replayer-club-page__tv-controls" aria-label={labels.controlsAriaLabel}>
      <button
        type="button"
        className={activeMode === 'replay' ? 'is-active' : ''}
        aria-pressed={activeMode === 'replay'}
        disabled={replayDisabled}
        onClick={onSelectReplay}
      >
        <span className="replayer-club-page__tv-control-number" aria-hidden="true">01</span>
        <span className="replayer-club-page__tv-control-copy">
          <strong>{labels.availableLabel}</strong>
          <span>{labels.availableDescription}</span>
        </span>
      </button>
      <button
        type="button"
        className={activeMode === 'upcoming' ? 'is-active' : ''}
        aria-pressed={activeMode === 'upcoming'}
        disabled={upcomingDisabled}
        onClick={onSelectUpcoming}
      >
        <span className="replayer-club-page__tv-control-number" aria-hidden="true">02</span>
        <span className="replayer-club-page__tv-control-copy">
          <strong>{labels.upcomingLabel}</strong>
          <span>{labels.upcomingDescription}</span>
        </span>
      </button>
      <button
        type="button"
        className={storeLoaded ? 'is-active' : ''}
        aria-pressed={storeLoaded}
        aria-busy={loadingStore}
        disabled={loadingStore}
        onClick={onOpenStore}
      >
        <span className="replayer-club-page__tv-control-number" aria-hidden="true">03</span>
        <span className="replayer-club-page__tv-control-copy">
          <strong>
            {loadingStore && <Spinner animation="border" size="sm" role="status"/>}
            {loadingStore ? labels.storeLoadingLabel : labels.storeLabel}
          </strong>
          <span>{labels.storeDescription}</span>
        </span>
      </button>
    </div>

    {showSubscriptionOptions && (
      <div className="replayer-club-page__tv-options">
        <button type="button" onClick={onOpenSubscriptionOptions}>
          {labels.viewOptionsLabel}
          <span aria-hidden="true">→</span>
        </button>
      </div>
    )}

    {loading && (
      <div className="replayer-club-page__tv-state" aria-busy="true">
        <Spinner animation="border" role="status"/>
        <div>
          <h3>{labels.loadingTitle}</h3>
          <p>{labels.loadingDescription}</p>
        </div>
      </div>
    )}

    {!loading && error && (
      <div className="replayer-club-page__tv-state replayer-club-page__tv-state--error" role="alert">
        <div>
          <h3>{labels.errorTitle}</h3>
          <p>{error}</p>
        </div>
        <button type="button" onClick={onRetry}>{labels.retryLabel}</button>
      </div>
    )}

    {!loading && !error && empty && (
      <div className="replayer-club-page__tv-state replayer-club-page__tv-state--empty">
        <img src={replayerTvIcon} alt="" aria-hidden="true"/>
        <div>
          <h3>{labels.emptyTitle}</h3>
          <p>{labels.emptyDescription}</p>
        </div>
      </div>
    )}

    {!loading && !error && children}
  </section>
);

PublicPartnerSkyworkTvSection.propTypes = {
  activeMode: PropTypes.oneOf(['replay', 'upcoming']).isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    logoUrl: PropTypes.string,
    name: PropTypes.string.isRequired
  })),
  children: PropTypes.node,
  empty: PropTypes.bool,
  error: PropTypes.node,
  labels: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  loadingStore: PropTypes.bool,
  onOpenStore: PropTypes.func.isRequired,
  onOpenSubscriptionOptions: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
  onSelectChannel: PropTypes.func.isRequired,
  onSelectReplay: PropTypes.func.isRequired,
  onSelectUpcoming: PropTypes.func.isRequired,
  replayDisabled: PropTypes.bool,
  selectedChannelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  showChannelFilter: PropTypes.bool,
  showSubscriptionOptions: PropTypes.bool,
  storeLoaded: PropTypes.bool,
  upcomingDisabled: PropTypes.bool
};

PublicPartnerSkyworkTvSection.defaultProps = {
  channels: [],
  children: null,
  empty: false,
  error: null,
  loading: false,
  loadingStore: false,
  replayDisabled: false,
  selectedChannelId: null,
  showChannelFilter: false,
  showSubscriptionOptions: false,
  storeLoaded: false,
  upcomingDisabled: false
};

export default PublicPartnerSkyworkTvSection;
